export default "__VITE_ASSET__BflI6bx0__"